import { ALGOLIA_INSIGHTS_EVENT_NAME } from '@monofront/business/constants';
import logger from '@utils/logger';
import { Hit } from 'instantsearch.js';
import { SendEventForHits } from 'instantsearch.js/es/lib/utils';
import aa from 'search-insights';

type InsightsEventProps =
  | { sendEvent: SendEventForHits; hit: Hit | Array<Hit> }
  | { productPageIndex: string; objectID: string };

export const createSubmitInsights = (props: InsightsEventProps) => {
  return () => {
    'sendEvent' in props
      ? props.sendEvent(
          // Not in the doc™️, but `click` forwards a `clickedObjectIDsAfterSearch` event to insights
          // See instantsearch.js/src/lib/utils/createSendEventForHits.ts
          'click',
          props.hit,
          ALGOLIA_INSIGHTS_EVENT_NAME.PRODUCT_CLICKED,
        )
      : aa('clickedObjectIDs', {
          eventName: ALGOLIA_INSIGHTS_EVENT_NAME.PRODUCT_CLICKED,
          objectIDs: [props.objectID],
          index: props.productPageIndex,
        });
  };
};

export const createAddToShoppingCartInsight = (props: InsightsEventProps) => {
  return () => {
    if ('sendEvent' in props && typeof props.sendEvent === 'function') {
      // Narrowed type: props has 'sendEvent' and 'hit'
      props.sendEvent(
        'conversion',
        props.hit,
        ALGOLIA_INSIGHTS_EVENT_NAME.PRODUCT_ADDED_TO_CART,
      );
    } else if ('objectID' in props && 'productPageIndex' in props) {
      // Narrowed type: props has 'objectID' and 'productPageIndex'
      aa('convertedObjectIDs', {
        eventName: ALGOLIA_INSIGHTS_EVENT_NAME.PRODUCT_ADDED_TO_CART,
        objectIDs: [props.objectID],
        index: props.productPageIndex,
      });
    } else {
      // Optional: Handle the case if neither type is matched
      logger.error('Invalid props provided to createAddToShoppingCartInsight', {
        props,
      });
    }
  };
};
